import { emitServices } from "./emitServices";
import { Services } from "@/types/serviceTypes";

export const toggleSelectedService = (
  serviceId: string,
  services: Services,
  forceServiceSelected?: boolean,
) => {
  const newServices: Services = [];
  for (const service of services) {
    if (service.id === serviceId) {
      newServices.push({
        ...service,
        selected: forceServiceSelected ? true : !service.selected,
      });
    } else {
      newServices.push(service);
    }
  }
  const selectedServices = newServices.filter((service) => service.selected);

  emitServices(selectedServices);
  return newServices;
};
